export default "dist/images/447bc31e61f55e7eff875be3e9a81f1a.png";